export default __webpack_public_path__ + "static/media/misc-pantry2-1024w.249df55a.webp";